import apis from '@/apis'
// 1在线 2离线 3告警 X0代表X+选中图标
const deviceIconList = new Map()
// 土壤温湿
deviceIconList.set('1001', {
  1: require('../../assets/img/mapIcon/device_1001_1.svg'),
  2: require('../../assets/img/mapIcon/device_1001_2.svg'),
  3: require('../../assets/img/mapIcon/device_1001_3.svg'),
  10: require('../../assets/img/mapIcon/device_1001_1_select.svg'),
  20: require('../../assets/img/mapIcon/device_1001_2_select.svg'),
  30: require('../../assets/img/mapIcon/device_1001_3_select.svg')
})
// 智慧监控
deviceIconList.set('1002', {
  1: require('../../assets/img/mapIcon/device_1002_1.svg'),
  2: require('../../assets/img/mapIcon/device_1002_2.svg'),
  10: require('../../assets/img/mapIcon/device_1002_1_select.svg'),
  20: require('../../assets/img/mapIcon/device_1002_2_select.svg')
})
// 水表
deviceIconList.set('1004', {
  1: require('../../assets/img/mapIcon/device_1004_1.svg'),
  2: require('../../assets/img/mapIcon/device_1004_2.svg'),
  10: require('../../assets/img/mapIcon/device_1004_1_select.svg'),
  20: require('../../assets/img/mapIcon/device_1004_2_select.svg')
})
// 垃圾桶
deviceIconList.set('1011', {
  1: require('../../assets/img/mapIcon/device_1011_1.svg'),
  2: require('../../assets/img/mapIcon/device_1011_2.svg'),
  3: require('../../assets/img/mapIcon/device_1011_3.svg'),
  10: require('../../assets/img/mapIcon/device_1011_1_select.svg'),
  20: require('../../assets/img/mapIcon/device_1011_2_select.svg'),
  30: require('../../assets/img/mapIcon/device_1011_3_select.svg')
})
// 空气质量
deviceIconList.set('1012', {
  1: require('../../assets/img/mapIcon/device_1012_1.svg'),
  2: require('../../assets/img/mapIcon/device_1012_2.svg'),
  10: require('../../assets/img/mapIcon/device_1012_1_select.svg'),
  20: require('../../assets/img/mapIcon/device_1012_2_select.svg')
})
// 智慧断路器
deviceIconList.set('1014', {
  1: require('../../assets/img/mapIcon/device_1014_1.svg'),
  2: require('../../assets/img/mapIcon/device_1014_2.svg'),
  10: require('../../assets/img/mapIcon/device_1014_1_select.svg'),
  20: require('../../assets/img/mapIcon/device_1014_2_select.svg')
})
// 水质监测
deviceIconList.set('1015', {
  1: require('../../assets/img/mapIcon/device_1015_1.svg'),
  2: require('../../assets/img/mapIcon/device_1015_2.svg'),
  10: require('../../assets/img/mapIcon/device_1015_1_select.svg'),
  20: require('../../assets/img/mapIcon/device_1015_2_select.svg')
})
// 虫情
deviceIconList.set('1017', {
  1: require('../../assets/img/mapIcon/device_1017_1.svg'),
  2: require('../../assets/img/mapIcon/device_1017_2.svg'),
  10: require('../../assets/img/mapIcon/device_1017_1_select.svg'),
  20: require('../../assets/img/mapIcon/device_1017_2_select.svg')
})

// 手环
deviceIconList.set('1006', {
  1: require('../../assets/img/mapIcon/device_1006_1.svg'),
  2: require('../../assets/img/mapIcon/device_1006_2.svg'),
  3: require('../../assets/img/mapIcon/device_1006_3.svg')
})
// 工牌
deviceIconList.set('1023', {
  1: require('../../assets/img/mapIcon/device_1006_1.svg'),
  2: require('../../assets/img/mapIcon/device_1006_2.svg'),
  3: require('../../assets/img/mapIcon/device_1006_3.svg')
})
// 喷灌
deviceIconList.set('penguan', {
  1: require('../../assets/img/mapIcon/icon_map_penguan_zaixian.svg'),
  2: require('../../assets/img/mapIcon/icon_map_penguan_lixian.svg')
})
// 流压
deviceIconList.set('liuya', {
  1: require('@/assets/icon/water/normal.svg'),
  2: require('@/assets/icon/water/offline.svg'),
  3: require('@/assets/icon/water/warning.svg')
})
export const deviceTypeParamList = new Map()
deviceTypeParamList.set('1001', 'soil')
deviceTypeParamList.set('1002', '')
deviceTypeParamList.set('1004', 'jgWaterInfo')
deviceTypeParamList.set('1011', 'jgTrashcanInfo')
deviceTypeParamList.set('1012', 'jgWeatherInfo')
deviceTypeParamList.set('1014', 'jgCircuitBreakerInfo')
deviceTypeParamList.set('1015', 'jgWaterQualityInfo')
deviceTypeParamList.set('1017', '')
deviceTypeParamList.set('liuya', 'jgWaterLyInfo')

// 1在线 2离线 3告警 X0代表X+选中图标
export const deviceTypeList = new Map()
deviceTypeList.set('1001', 'A0')
deviceTypeList.set('1002', 'VI')
deviceTypeList.set('1004', 'B0')
deviceTypeList.set('1011', 'H0')
deviceTypeList.set('1012', 'I0')
deviceTypeList.set('1014', 'C0')
deviceTypeList.set('1015', 'L0')
deviceTypeList.set('1017', 'M0')
// deviceTypeList.set('1017', 'E0')
deviceTypeList.set('liuya', 'AB')
deviceTypeList.set('1023', 'S0')
deviceTypeList.set('1006', 'D0')

// 接口
export const deviceAjax = new Map()
deviceAjax.set('1001', apis.iot.selectSoilInfoByPage)
deviceAjax.set('1002', apis.iot.selectCameraDemoInfoByPage)
deviceAjax.set('1004', apis.iot.selectWaterInfoByPage)
deviceAjax.set('1011', apis.iot.selectTrashcanInfoByPage)
deviceAjax.set('1012', apis.iot.selectWeatherInfoByPage)
deviceAjax.set('1014', apis.iot.selectJgCircuitBreakerInfoByPage)
deviceAjax.set('1015', apis.iot.selectWaterQualityInfoByPage)
deviceAjax.set('1017', apis.iot.selectInsectInfoByPage)
deviceAjax.set('penguan', apis.iot.selectJgIrrigationValveByPage)
deviceAjax.set('workcard', apis.iot.selectYhWorkerDeviceByList)
deviceAjax.set('bracret', apis.iot.selectYhWorkerDeviceByList)
deviceAjax.set('liuya', apis.iot.selectWaterLyInfoByPage)

// 编辑

export const updateAjax = new Map()
updateAjax.set('1001', apis.iot.updateSoilInfoLocation)
updateAjax.set('1002', apis.iot.updateCameraDemoInfoLocation)
updateAjax.set('1004', apis.iot.updateWaterInfoLocation)
updateAjax.set('1011', apis.iot.updateTrashcanInfoLocation)
updateAjax.set('1012', apis.iot.updateWeatherInfoLocation)
updateAjax.set('1014', apis.iot.updateJgCircuitBreakerInfoLocation)
updateAjax.set('1015', apis.iot.updateWaterQualityInfoLocation)
updateAjax.set('1017', apis.iot.updateInsectInfoLocation)
updateAjax.set('penguan', apis.iot.updateJgIrrigationValveLocation)
updateAjax.set('workcard', apis.iot.updateWorkerInfoName)
updateAjax.set('bracret', apis.iot.updateWorkerInfoName)
updateAjax.set('liuya', apis.iot.updateJgWaterLyInfoThreshold)

// 未绑定cad
const cadUnBindMapIcon = require('../../assets/img/mapIcon/noBindDevice.svg')
const LocationImg = require('@/assets/img/location.png')

export const getMapIcon = (key, data, isBig) => {
  if (data.isCurrent || data.isCurrentHasCad) {
    return LocationImg
  }
  if (!data.deviceNumber) {
    return cadUnBindMapIcon
  }
  let runStatus = data.runStatus
  // 厕所告警
  if (+key === 1011) {
    runStatus = data.trashcan1Status
  }
  // 厕所告警
  if (key === 'liuya') {
    runStatus = data.pressureStatus || data.runStatus
  }
  if ([1006, 1023].includes(+key)) {
    runStatus = data.sosStatus
  }
  const name = (+data.deviceStatus || 2) === 1 ? runStatus && runStatus !== '0' ? 3 : 1 : 2
  const icon = deviceIconList.get(key)[isBig ? name + '0' : name]
  return icon
}
